import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OauthService } from '../services/oauth.service';
import { RepoService } from '../services/repo.service';
import { ToastService } from '../services/toast.service';

export const workspaceAccessGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const auth = inject(OauthService);
  const repoService = inject(RepoService);
  const toastService = inject(ToastService);
  // Check if user is authenticated
  const userInfo = await auth.getUser();
  if (!userInfo) {
    console.log('Access to workspace denied: User not authenticated');
    router.navigate(['/']);
    return false;
  } else {
    if (!userInfo.app_access) {
      router.navigate(['/']);
      return false;
    }
  }

  if (!repoService.repo()) {
    console.log('Access to workspace denied: No repository selected');
    toastService.showError('Please connect the repository to access the workspace');
    router.navigate(['/']);
    return false;
  }

  // If user is authenticated, allow access to workspace
  return true;
};
